import React, { useEffect, useState } from 'react';
import '../assets/css/custom.css';
import '../assets/css/client.css';
import '../assets/css/font-awesome.css';
import '../assets/css/sweetalert.css';
import '../assets/css/bootstrap.min.css';
import Modal from 'react-bootstrap/Modal';
import { commonAPI } from "../services/CommonAPIService";
import { FaChevronDown } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMotorcycle, faCar, faEdit, faL, faPlus, faSort, faTrash, faEllipsisVertical, faTrashCan, faPenToSquare, faPaperclip } from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import { ToastContainer, toast } from "react-toastify";
import FlatIcon from '../assets/img/config-flat.png';
import vehicleBrand from '../assets/img/vehiclebrand.png';
import { useNavigate } from "react-router-dom";

const Brand = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const [logo, setImageLogo] = useState()
  const [loading, setLoading] = useState(false)
  const [VehicleType, setVehicleType] = useState("4WHEELER")
  const [VehicleTypeBtnBike, setVehicleTypeBtnBike] = useState(false);
  const [VehicleTypeBtnCar, setVehicleTypeBtnCar] = useState(true);
  const [fileName, setFileName] = useState('');
  const [fileURL, setFileURL] = useState('');
  const [base64, setBase64] = useState('');
  const [brandName, setBrandName] = useState('')
  const [country, setSelectCountry] = useState('')
  const [defaultCountryId, setSelectDefaultCountyId] = useState()
  const [seq, setSequence] = useState()
  const [popularBrand, setPopularBrand] = useState(true)
  const [imgSizeLarge, setImgSizeLarge] = useState(false)
  const [DeleteShow, setDeleteShow] = useState(false);
  const [deleteItem, setDeleteItem] = useState();
  const [brandId, setbrandId] = useState()
  const [ModalText, setModalText] = useState(false)
  const [updatedEdit, setUpdatedEdit] = useState(false)
  const [cloneBrand, setcloneBrand] = useState()
  const [showSelectData,setShowSelectData] = useState("4WHEELER")
  console.log("VEHICLETYPE", VehicleType, base64)
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {

      if (!/\.(jpeg|jpg|png)$/i.test(file?.name)) {
          toast.error("Please select an image in JPEG, JPG, or PNG format.");
      } else if (file?.size >= 50000) {
          toast.error("Please select a logo with a size below 50KB.");
      } else {
            const reader = new FileReader();

            reader.onload = () => {
              setFileURL(reader.result);
              setBase64(reader.result);
            };
            reader.readAsDataURL(file);
      }

  }
    // if (file.type == 'image/jpeg' || file.type == 'image/png' && file.size <= 5000) {
    //   setImgSizeLarge(false)
    //   const reader = new FileReader();
    //   reader.onload = function (e) {
    //     const imageUrl = e.target.result;
    //     console.log(imageUrl);
    //     setFileURL(imageUrl);
    //     console.log("Hjha")
    //     const myBase64Image = imageUrl
    //     setBase64(myBase64Image)
    //     console.log(myBase64Image[1])
    //   };
    //   reader.readAsDataURL(file);
    // }
    // else {
    //   setImgSizeLarge(true)
    //   toast.error("Please select a logo with a size below 50KB.");
    // }
    // console.log(event.target.files[0])
  }
  const openCreateModal = () => {
    // if (updatedEdit == true) {
      setFileURL("")
      setBase64("data:image/png;base64," + logo)
      setBrandName("")
      setSequence("")
      setShow("")
      setbrandId("")
      setPopularBrand(true)
      setShow(true)
      setModalText(true);
      setUpdatedEdit(false)
      if(showSelectData == "4WHEELER"){
        VehicleCar();
      }else{
        VehicleBike();
      }
    // }
    // else {
    //   setShow(true)
    //   setModalText(true);
    // }

    // toast.warning("Please select building");

  };
  const fetchData = async () => {
    setLoading(true)
    try {
      let response = await commonAPI("getVehicleLogo");
      if (response.success == true) {
        console.log(response);
        setImageLogo(response.data)
        setcloneBrand(response.data)

        setLoading(false)
      }
      else {
        toast.warning("Something went wrong")
      }

    } catch (error) {
      console.error("Error fetching vehicle logo:", error);
      setLoading(false)
    }
  };
  useEffect(() => {
    fetchData();
    SelectCountry();
  }, []);

  async function SelectCountry() {

    try {
      const response = await commonAPI("Country", undefined);
      if (response?.success == true) {
        console.log(response, "COUNTYTY")
        setSelectCountry(response.data)
        const getDefaultcountry = response.data.filter((data) => {
          return data.countryName.toLowerCase() == "india"

        })
        console.log(getDefaultcountry, "GETDEFAULT COUNTRY")
        setSelectDefaultCountyId(getDefaultcountry.countryId)
      }

    }
    catch (error) {
      console.log(error)
    }

  }

  const VehicleCar = () => {
    setVehicleTypeBtnCar(true)
    setVehicleTypeBtnBike(false)
    setVehicleType("4WHEELER")
    try {
       localStorage.setItem("VehicleType", JSON.stringify("4WHEELER"));
    } catch (e) {
      // saving error
      console.error("Error storing data", e);
    }
  }
  const VehicleBike =  () => {
    setVehicleTypeBtnCar(false)
    setVehicleTypeBtnBike(true)
    setVehicleType("2WHEELER")
    try {
       localStorage.setItem("VehicleType", JSON.stringify("2WHEELER"));
    } catch (e) {
      // saving error
      console.error("Error storing data", e);
    }
  }

  async function uploadLogo() {
    if (!fileURL) {
      toast.warning("Please upload Brand Logo")
      setLoading(false)
      return
    }
    else if (!brandName) {
      toast.warning("Please enter Brand Name")
      setLoading(false)
      return
    }
    else if (!seq) {
      toast.warning("Please enter Sequence Number")
      setLoading(false)
      return
    }
    const bodyReq = {
      "isActive": true,
      "brandName": brandName,
      "vehicleType": VehicleType,
      "country": "India",
      "popularBrand": popularBrand,
      "seq": seq,
      "logo": base64
    }
    console.log("bodyReq", bodyReq)
    setLoading(true)
    try {
      const response = await commonAPI("VehicleBrandPost", bodyReq)
      if (response.success == true) {
        setLoading(false)
        console.log(response)
        setShow(false)
        getData();
        fetchData();
        toast.success("Vehicle Brand Added")
        setBase64("");
        setBrandName("");
        setFileURL("")
        setSequence(null)
      } else {
        toast.error(response.message[0]);
        setLoading(false);
      }

    }
    catch (error) {
      console.log(error)
    }
  }



  async function DeleteBrandLogo() {
    console.log(deleteItem, "DeleteItem")
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId
    }
    console.log(myUserData)
    const bodyReq = {
      "modifiedUserId": myUserData?.userId.toString(),
      "createdUserId": myUserData?.userId.toString(),
      "vehicleBrandId": deleteItem,
    }
    console.log(bodyReq)
    try {
      const response = await commonAPI("DeleteVehicleLogo", bodyReq, endPointVariableKey)
      console.log(response, "RESPONSe")
      if (response?.success == true) {
        setLoading(false)
        console.log(response)
        setDeleteShow(false)
        fetchData();
        toast.success("Vehicle Brand Deleted")
      }
      else {
        toast.warning(response?.message[0])
        setLoading(false)
      }

    }
    catch (error) {
      setLoading(false)
      console.log(error)
    }
  }
  function updateCompanyLogo(logo, BrandName, vehicleType, brandId, seq,popular) {
    console.log(popular,"POPULAR")
    console.log(seq, "SEQ")
    console.log("vehicleType",vehicleType)
    setFileURL("data:image/png;base64," + logo)
    setBase64("data:image/png;base64," + logo)
    setBrandName(BrandName)
    setSequence(seq)
    setShow(true)
    setbrandId(brandId)
    setVehicleType(vehicleType)
    if(vehicleType == "4WHEELER"){
      VehicleCar()
    }else{
      VehicleBike()
    }
    setPopularBrand(popular)
    setModalText(false)
    setUpdatedEdit(true)
  }
  async function performUpdate() {
    if (!brandName) {
      toast.warning("Please enter Company Name")
      return
    }
    // else if (!seq) {
    //   toast.warning("Please enter Sequence Number")
    //   return
    // }
    else if (!base64) {
      toast.warning("Please Upload Company Logo")
      return
    }
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const bodyReq = {
      "brandName": brandName,
      "vehicleType": VehicleType,
      "popularBrand":popularBrand,
      "logo": base64,
      "modifiedUserId": myUserData?.userId.toString(),
      "createdUserId": myUserData?.userId.toString(),
      "vehicleBrandId": brandId,
      "seq": seq,
    }
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId
    }
    console.log(bodyReq)
    setLoading(true)
    try {
      const response = await commonAPI("updateVehicleLogo", bodyReq, endPointVariableKey)
      if (response.success == true) {
        setLoading(false)
        console.log(response)
        setShow(false)
        fetchData();
        toast.success("Vehicle Brand Updated")
        setBase64("");
        setBrandName("");
        setFileURL("")
      }
      else {
        toast.warning(response?.message[0])
        setLoading(false)
      }

    }
    catch (error) {
      setLoading(false)
      console.log(error)
    }
  }
  console.log(popularBrand, "Popular Brand")
  const getData = (key) => {
    try {
      const value = localStorage.getItem("VehicleType");
      if (value !== null) {
        console.log(value,"VALUEEE")
        setFilterAsBrand(JSON.parse(value))
        return JSON.parse(value);
      }
    } catch (e) {
      console.error("Error retrieving data", e);
    }
    return null;
  };

  function setFilterAsBrand(data) {
    console.log("i will called I think")
    console.log(data,"DATA");

    let filteredBrand;

    if (data == "ALL") {
      // Reset the filter by setting filteredBrand to the original cloneBrand
      filteredBrand = cloneBrand;
    } else {
      // Apply the filter
      filteredBrand = cloneBrand?.filter((brandType) => {
        return data == brandType?.vehicleType;
      });
    }

    console.log(filteredBrand,"FILTEREDDATA");
    setImageLogo(filteredBrand);
  }
  // useEffect(()=>{
    
  //     setTimeout(() => {
  //       localStorage.removeItem("VehicleType");
  //       // Optionally, you can also clear all localStorage using localStorage.clear()
  //     }, 2000); // 5000 milliseconds = 5 seconds
  //     console.log("I am called TimeOut")
  // },[])
  useEffect(() => {
    if (logo?.length !== 0) { // Check if logo is defined and not empty
      console.log("I will trigger");
      console.log(logo);
      const value = localStorage.getItem("VehicleType");
      if(JSON.parse(value)==null){
        const filteredBrand = cloneBrand?.filter((brandType) => {
          return "4WHEELER" === brandType?.vehicleType;
        });
        console.log(filteredBrand, "FILTEREDDATA");
        setImageLogo(filteredBrand); // This should not affect `logo`
      }
      else{
        const filteredBrand = cloneBrand?.filter((brandType) => {
          return JSON.parse(value) === brandType?.vehicleType;
        });
        console.log(JSON.parse(value),"SELECT DATA")
        setShowSelectData(JSON.parse(value))
        console.log(filteredBrand, "FILTEREDDATA");
        setImageLogo(filteredBrand);
      }
     
  
      
    }
  }, [cloneBrand]);
 
  return (<>
    {loading ?
      <div className="loaderDiv">
        <div className="loader"></div>
      </div>
      : null}
    <div className="row mt-5 pt-2" style={{ alignItem: 'center' }}>
      <div className="col-lg-6 col-md-6">
        <div className="HeadingTop">
          <h3>Vehicle Brands </h3>
          <span> Maintain an updated database of recognized vehicle brands.</span>
        </div>
      </div>
      <div className="col-lg-6 col-md-6  text-right d-flex align-items-center flex-row-reverse mb-3 mb-md-0" style={{ alignContent: 'center' }}>
      <Button className="createClr" onClick={openCreateModal}>+ Create New</Button>{" "} 
        <div className="form-group fixChevron d-flex justify-content-between align-items-center">
          <select value={showSelectData} name="taskTypes" style={{width:"120px"}} className="form-control" onChange={(e) => { setFilterAsBrand(e.target.value);setShowSelectData(e.target.value);localStorage.setItem("VehicleType", JSON.stringify(e.target.value)); }}>
            <option  value="4WHEELER">
              4 Wheeler
            </option>
            <option value="2WHEELER">
              2 Wheeler
            </option>
          </select>
          <FaChevronDown style={{bottom:"32%"}} className="absChevron" size={"10px"} />
        </div>
       
      </div>
    </div>


    <Modal size="md" show={show} onHide={() => setShow(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter ">
      <Modal.Header closeButton className='headerMDL'>
        <Modal.Title id="contained-modal-title-vcenter" onClick={openCreateModal}>
          {ModalText ? "Add Vehicle Brand" : "Update Vehicle Brand"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="helpingElelemnt_uuy002">


        <div className="container">
              <div className="row text-left">
                          <div className="col-md-12 mb-5 px-0">
                            {imgSizeLarge && <div className="imgSizeLine text-center small">Image Size is Exceeded </div>}
                            <div className="form-group parentUploadContainer">

                              <div className="" for="wfirstName2">

                                <label for="wfirstName2" className='uploadcontainer'> <FontAwesomeIcon icon={faPaperclip} />  &nbsp; Browse Brand Logo  <span className="danger">*</span>
                                  <input type="file" onChange={(e) => { handleFileChange(e) }} value={''} className="form-control required" id="wfirstName2" name="firstName" aria-required="true" />
                                  {fileURL && <img src={fileURL} alt="Selected" className="img-fluid" style={{ width: "100px" }} />}
                                </label>
                              </div>
                              

                            </div>
                            <label className="text-danger mb-0"><span className="danger">*</span> Allowed File Types- JPEG/JPG/PNG.</label> <br/>
                                                <label className="text-danger mb-0"><span className="danger">*</span>Maximum image size - 50KB</label>
                                                <br/> <br/>
                            <div className="col-md-12 mb-2 text-center">
                              <div className='fam_vehicleBtn'>
                                <input type="file" />
                                {VehicleTypeBtnCar ?
                                  <FontAwesomeIcon icon={faCar} onClick={() => VehicleCar()} className='fam_vehicleBtnicon bg-info text-white' />
                                  :
                                  <FontAwesomeIcon icon={faCar} onClick={() => VehicleCar()} className='fam_vehicleBtnicon text-info border-info' />
                                }
                                {VehicleTypeBtnBike ?
                                  <FontAwesomeIcon icon={faMotorcycle} onClick={() => VehicleBike()} className='fam_vehicleBtnicon bg-info text-white' />
                                  :
                                  <FontAwesomeIcon icon={faMotorcycle} onClick={() => VehicleBike()} className='fam_vehicleBtnicon text-info border-info' />


                                }
                              </div>
                            </div>

                            <div className="form-group">
                              <label for="wlastName2"> Brand Name  <span className="danger">*</span> </label>
                              <input type="text" value={brandName} onChange={(e) => { setBrandName(e.target.value) }} className="form-control required" id="wlastName2" name="lastName" aria-required="true" /> </div>

                            <div className="form-group mt-2">
                              <label for="wlastName2"> Popular Brand  <span className="danger">*</span> </label>
                              <div>
                                <input type="radio" value="true" onChange={() => { setPopularBrand(true) }} className="form-control required" id="popularBrandYes" name="popularBrand" aria-required="true" defaultChecked={popularBrand === true}  />
                                <label htmlFor="popularBrandYes">Yes</label>

                                <input type="radio" value="false" onChange={() => { setPopularBrand(false) }} className="form-control required" id="popularBrandNo" name="popularBrand" aria-required="true" defaultChecked={popularBrand === false}/>
                                <label htmlFor="popularBrandNo">No</label>
                              </div>

                            </div>

                            <div className="form-group mt-2">
                              <label >Country <span className="danger">*</span></label>
                              <select name="taskTypes" className="form-control" value={defaultCountryId} onChange={(e) =>
                                setSelectCountry(e.target.value)} disabled>
                                {country ? country?.map((item, index) => (
                                  <option key={index} value={item.countryId}> {item.countryName} </option>
                                ))
                                  : null}
                              </select>

                            </div>
                            <div className="form-group mt-2" style={{marginBottom: 100}}>
                              <label for="wlastName2"> Sequence  <span className="danger">*</span> </label>
                              <input type="number" value={seq} onChange={(e) => { setSequence(e.target.value) }} className="form-control required" id="wlastName2" name="lastName" aria-required="true" /> </div>
                          </div>
                        </div>
                </div>
      </Modal.Body>


      <div className="cutomStriper">

        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
          <div className="d-flex flex-row-reverse">

          <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
          {brandId ? <button type="button" className="btn btn-info" onClick={() => { performUpdate() }}> Update</button> : <button type="button" className="btn btn-info" onClick={() => { uploadLogo() }}> Submit</button>}
          </div>
        </div>

      </div>
 


    </Modal>



    <div className="row">
      {logo?.map((logoImg, index) => {
        return <div className="col-lg-3 col-md-6 col-sm-12 col-12" key={index}>
          <div className="clientTiles" style={{ height: 125 }}>
            <div className="ClientImg">
              <div className="tabs_img">
                <img src={`data:image/jpeg;base64,${logoImg.logo}`} alt={`Logo ${index}`} class="img img-responsive" />
              </div>
              <div class="bars_font">
                <h3 className="font_trigger"   onClick={() => {
                    updateCompanyLogo(logoImg.logo, logoImg.brandName, logoImg.vehicleType, logoImg.vehicleBrandId, logoImg.seq,logoImg.popularBrand
                    )
                  }} >
                  {<FontAwesomeIcon icon={faPenToSquare}/>}
                </h3>
                <h3 className="font_trigger" onClick={() => { setDeleteShow(true); setDeleteItem(logoImg.vehicleBrandId) }} >
                  <FontAwesomeIcon icon={faTrashCan} />
                </h3>
              </div>
            </div>
            <div className="ClientText">
              <div className="l-two">
                <h1> {logoImg.brandName} </h1>
                {/* <h4>{item?.buildingName} </h4> */}
              </div>
            </div>
          </div>
        </div>

      })}

      {logo?.length == 0 ? (!logo?.length && logo?.length != null &&
        <div className='bg-white' style={{ height: "400px", borderRadius: "10px" }}>
          <div className='col-12 text-center'>
            <img src={vehicleBrand} alt="user" class="mx-auto mt-5" style={{ height: "150px" }} />
          </div>
          <br />
          <h3 className='col-12 text-center' style={{ marginTop: "0px" }}> No Vehicle Brand Found</h3>
          <h5 className='col-12 text-center' style={{ marginTop: "10px" }}> Click on Create New button to add a Vehicle Brand</h5>
        </div>) : null}
    </div>



    <Modal centered show={DeleteShow} onHide={() =>
      setDeleteShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
      {/* <Modal.Header className="headerMDL" closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" centered onClick={openCreateModal}>
                        <h4 className="mb-0"> Delete Tower </h4>
                    </Modal.Title>
                </Modal.Header> */}
      <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
        <div className="row px-3" id="validation">
          <div className="col-12 bg-white pt-3 pb-2">
            <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
              {/* <div className="FnFimg">
                                <img src={stopMark} className='img img-fluid img-responsive'  alt="placeholder" />
                            </div> */}
              <div className="FnFtxt">
                <h2> Delete Vehicle Brand </h2>
                <h3> Are you sure you want to delete? </h3>
              </div>
            </div>

          </div>

        </div>
        <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
          <div className='both_ConfrmBTN col-6' onClick={() => DeleteBrandLogo()}>
            <Button variant="danger">Delete</Button>{' '}
          </div>
          <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShow(false)} >
            <Button variant="light"> Cancel</Button>{' '}
          </div>
        </div>
      </Modal.Body>
    </Modal>
    <ToastContainer />
  </>)
}
export default Brand